const SET_STATUS_COLORS = "SET_STATUS_COLORS";
const SET_PARTY_COLORS = "SET_PARTY_COLORS";
const SET_REPUBLICAN_COLORS = "SET_REPUBLICAN_COLORS";
const SET_DEMOCRATIC_COLORS = "SET_DEMOCRATIC_COLORS";
const SET_CANDIDATE_OVERRIDES = "SET_CANDIDATE_OVERRIDES";

const state = {
  colors: {
    status: {
      none: "#666666",
      active: "#D84B44",
      done: "#57AEA6",
      called: "#57AEA6",
    },
    party: {
      "Democratic": "var(--dem-color)",
      "Republican": "var(--gop-color)",
      "Green": "var(--gre-color)",
      "Libertarian": "var(--lib-color)",
      "Progressive": "var(--prog-color)",
      "Independent": "var(--ind-color)",
      "United Utah": "var(--uu-color)",
      "Other": "var(--oth-color)",
    },
    primary: {
      republican: [
        "var(--gop-primary-0)",
        "var(--gop-primary-1)",
        "var(--gop-primary-2)",
        "var(--gop-primary-3)",
        "var(--gop-primary-4)",
        "var(--gop-primary-5)",
        "var(--gop-primary-6)",
        "var(--gop-primary-7)",
        "var(--gop-primary-8)",
        "var(--gop-primary-9)",
        "var(--gop-primary-10)",
        "var(--gop-primary-11)",
        "var(--gop-primary-12)",
        "var(--gop-primary-13)",
        "var(--gop-primary-14)",
        "var(--gop-primary-15)",
        "var(--gop-primary-16)",
        "var(--gop-primary-17)",
      ],
      republicanCustom: [],
      democratic: [
        "var(--dem-primary-0)",
        "var(--dem-primary-1)",
        "var(--dem-primary-2)",
        "var(--dem-primary-3)",
        "var(--dem-primary-4)",
        "var(--dem-primary-5)",
        "var(--dem-primary-6)",
        "var(--dem-primary-7)",
        "var(--dem-primary-8)",
        "var(--dem-primary-9)",
        "var(--dem-primary-10)",
        "var(--dem-primary-11)",
        "var(--dem-primary-12)",
        "var(--dem-primary-13)",
        "var(--dem-primary-14)",
        "var(--dem-primary-15)",
        "var(--dem-primary-16)",
        "var(--dem-primary-17)",
      ],
      democraticCustom: [],
      candidateOverrides: [
        12691, 48471, 11868, 49574, 49580, 49575, 5, 52490, 649, 52491, 9193, 64, 52489, 11918,
        11966, 10507, 53435, 14463, 13858,
      ],
    },
  },
};

const mutations = {
  [SET_STATUS_COLORS](state, colors) {
    state.colors.status = colors;
  },
  [SET_PARTY_COLORS](state, colors) {
    state.colors.party = colors;
  },
  [SET_REPUBLICAN_COLORS](state, colors) {
    state.colors.primary.republicanCustom = colors;
  },
  [SET_REPUBLICAN_COLORS](state, colors) {
    state.colors.primary.republicanCustom = colors;
  },
  [SET_DEMOCRATIC_COLORS](state, colors) {
    state.colors.primary.democraticCustom = colors;
  },
  [SET_DEMOCRATIC_COLORS](state, colors) {
    state.colors.primary.democraticCustom = colors;
  },
  [SET_CANDIDATE_OVERRIDES](state, obj) {
    state.colors.primary.candidateOverrides = obj;
  },
};

const actions = {
  setStatusColors: ({ commit }, colors) => {
    commit(SET_STATUS_COLORS, colors);
  },
  setPartyColors: ({ commit }, colors) => {
    commit(SET_PARTY_COLORS, colors);
  },
  setRepublicanColors: ({ commit }, colors) => {
    commit(SET_REPUBLICAN_COLORS, colors);
  },
  setDemocraticColors: ({ commit }, colors) => {
    commit(SET_DEMOCRATIC_COLORS, colors);
  },
  setCandidateColorOverrides: ({ commit }, obj) => {
    commit(SET_REPUBLICAN_COLORS, obj);
  },
};

const getters = {
  colors(state) {
    return state.colors;
  },
};

export default {
  namespaced: false,
  state,
  mutations,
  actions,
  getters,
};
